// eslint-disable-next-line import/no-anonymous-default-export
const en = {
  descriptionBold: 'Thank you for your interest.',
  description: 'Search and select the required appointment.',
  eventTypeTitles: {
    '': '',
    Youngster: 'Youngster (13 - 16 years old)',
	  'Job Info Events': 'Job Info Events',
	  Visits: 'Guided Tours',
    'Recruitment Days (1d)': 'Recruitment Days (1d)',
    'Recruitment Days (1d+)': 'Recruitment Days (1d+)',
    Internal: 'Internal',
  },
  noEvents: 'There are currently no free dates available. We will add new dates soon. Thank you for your patience.',
  loadError: 'The dates could not be loaded right now. Please reload the page or try again in a few minutes.',
  noGuidedTours: "We will add new dates soon. Thank you for your patience. In the meantime, you can contact us using the following form: <1>Request a Guided Tour</1>",
  filters: {
    eventType: 'Change the type of event',
    startDate: 'From',
    endDate: 'Until',
    location: 'Location',
    languageLabel: 'Language',
    language: {
      title: 'Select language',
      en: 'English',
      fr: 'French',
      it: 'Italian',
      de: 'German',
    },
    search: 'Search',
    clear: 'Reset',
  },
  card: {
    startDate: 'Start date:',
    startHour: 'Start time:',
    endDate: 'End date:',
    endHour: 'End time:',
    until: 'until',
  },
  contact: 'Contact',
  contactDesc: 'Any questions? Feel free to call us on 043 931 6111 or email us at',
  feast: {
    title: 'FEAST 1 Test Registration',
    subtitle: "Skyguide's FEAST tests are by invitation only and require prior application. If you haven't already done so, please apply <1>here</1> for the corresponding air traffic controller training.",
    filterTitle: 'Search and select the required appointment.'
  },
  schoolOfCompetence: {
    title: 'School of Competence',
    subtitle: 'Discover the workshops of the skyguide School of Competence and register for the one that suits you.',
    filterTitle: 'Search and select the required appointment.',
    filterLabel: 'School of Competence',
  },
};

export default en;